import { Injectable } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "@app/_services";
import { Users } from "@app/_models";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { ApplicationStateService } from "@app/_services/application-state.service";

@Component({
  selector: "app-subscriptions",
  templateUrl: "./subscriptions.component.html",
  styleUrls: ["./subscriptions.component.css"],
})
@Injectable({ providedIn: "root" })
export class SubscriptionsComponent implements OnInit {
  private searchSubject: Subject<void> = new Subject();
  apiUrl = null;
  loading = true;
  public users: any = [];
  public usersToDisplay: any = [];
  userRole = null;
  showSelectUser = false;
  creditToAdd = 0;
  selectedUser = 0;
  successCredit = false;
  failCredit = false;
  isVisible = false;
  userSelected: Users;
  userSelectedName = "";
  searchValueEmail = "";
  searchValueName = "";
  searchSubscriptionType = "";
  searchSubscriptionVal = "";
  searchStatus = "";
  visible = false;
  searchCreationDate = "";
  searchCancelDate = "";
  searchLastPaidDate = "";
  searchNextPaymentDate = "";
  selectedSubscriptionType: string = "all";
  pageIndex = 1;
  totalPages = 1;
  pageSize = 10;
  isMobile = false;

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, private router: Router, private http: HttpClient, public apiBackendService: ApiBackendService, private applicationStateService: ApplicationStateService) {
    //redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate(["/login"]);
    } else if (this.authenticationService.currentUserInfo.role != "admin") {
      this.router.navigate(["/"]);
    }
    this.userRole = this.authenticationService.currentUserInfo.role;
    this.apiUrl = this.authenticationService.apiUrl;
    this.searchSubject.pipe(debounceTime(500)).subscribe(() => {
      this.getUsers();
    });
    if (applicationStateService.getIsMobileResolution()) {
      this.isMobile = true;
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.getUsers();

    // this.getCredit();
  }

  getUsers() {
    const filterQuery = new Object();
    filterQuery["searchName"] = this.searchValueName;
    filterQuery["searchEmail"] = this.searchValueEmail;
    filterQuery["searchSubscriptionType"] = this.searchSubscriptionType;
    filterQuery["searchSubscriptionVal"] = this.searchSubscriptionVal;
    filterQuery["searchCreationDate"] = this.searchCreationDate;
    filterQuery["searchCancelDate"] = this.searchCancelDate;
    filterQuery["searchLastPaidDate"] = this.searchLastPaidDate;
    filterQuery["searchNextPaymentDate"] = this.searchNextPaymentDate;
    filterQuery["searchStatus"] = this.searchStatus;

    this.apiBackendService
      .getSubscriptionsPaginated(this.pageSize, this.pageIndex, filterQuery)
      .pipe()
      .subscribe((res) => {
        this.totalPages = res.body["total_pages"] * this.pageSize;
        this.users = res.body["results"];
        this.usersToDisplay = res.body["results"];
        this.loading = false;
      });
  }

  toggleShowSelectUser(entryId) {
    this.showSelectUser = !this.showSelectUser;
    this.selectedUser = entryId;
  }
  saveChangedUser(entryId) {
    this.showSelectUser = !this.showSelectUser;
    this.selectedUser = 0;

    if (this.creditToAdd < 0) {
      this.apiBackendService
        .removeCreditToUser(entryId, this.creditToAdd * -1)
        .pipe()
        .subscribe((res) => {
          if (res.status == 200) {
            this.successCredit = true;
            const userIndex = this.users.findIndex((user) => user.id.toString() === entryId.toString());
            let user = this.users[userIndex];
            const newCredit = Number(user.credit) + Number(this.creditToAdd);
            user.credit = newCredit;
            this.users[userIndex] = user;
          } else {
            this.failCredit = true;
          }
          this.creditToAdd = 0;
        });
    } else {
      this.apiBackendService
        .addCreditToUser(entryId, this.creditToAdd)
        .pipe()
        .subscribe((res) => {
          if (res.status == 200) {
            this.successCredit = true;
            const userIndex = this.users.findIndex((user) => user.id.toString() === entryId.toString());
            let user = this.users[userIndex];
            const newCredit = Number(user.credit) + Number(this.creditToAdd);
            user.credit = newCredit;
            this.users[userIndex] = user;
          } else {
            this.failCredit = true;
          }
          this.creditToAdd = 0;
        });
    }
  }

  onChange(event) {
    console.log(event);

    if (event != "status") {
      this.usersToDisplay = this.users.filter((item: Users) => item.status == event);
    } else {
      this.usersToDisplay = this.users;
    }
  }

  pageIndexChanged(e) {
    console.log("page index changed", e);
    this.pageIndex = e;
    this.getUsers();
  }

  pageSizeChanged(e) {
    console.log("page size changed", e);
    this.pageSize = e;
    this.getUsers();
  }

  onQueryParamsChange(e) {
    console.log(e);
  }

  filterBy() {
    this.pageIndex = 1;
    this.searchSubject.next();
  }

  filterBySubscriptionType(event: string) {
    this.selectedSubscriptionType = event;
    this.applyFilters();
  }

  applyFilters() {
    this.usersToDisplay = this.users.filter((user) => {
      const matchesType = this.selectedSubscriptionType === "all" || user.subscriptionType === this.selectedSubscriptionType;
      return matchesType;
    });
  }
}
